// Google Analytics utility functions
export const GA_TRACKING_ID = 'G-4Z47S2NL73';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: true
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      page_title: document.title,
      page_location: window.location.href
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('click', 'button', `${buttonName}_${location}`);
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('submit', 'form', formName);
};

// Track downloads
export const trackDownload = (fileName) => {
  trackEvent('download', 'file', fileName);
};

// Track external link clicks
export const trackExternalLink = (url) => {
  trackEvent('click', 'external_link', url);
};

// Check if analytics is loaded
export const isAnalyticsLoaded = () => {
  return typeof window !== 'undefined' && window.gtag;
};
